import { Component } from "@theme/component";

class CollectionComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
  }

  filterScent(clickedElement) {
    const scentHandle =
      typeof clickedElement === "string"
        ? clickedElement
        : clickedElement?.dataset?.handle;
    this.refs.products.forEach((product) => {
      if (scentHandle && scentHandle == "all") {
        product.classList.add("visible");
      } else {
        if (scentHandle && product.dataset.scent == scentHandle) {
          product.classList.add("visible");
        } else {
          product.classList.remove("visible");
        }
      }
    });
  }

  sortProducts(sortKey) {
    const grid = this.querySelector(".collection-component-bottom");
    if (!grid || !this.refs.products) return;

    const products = [...this.refs.products];
    const sorted = products.filter((product) =>
      product.classList.contains("visible"),
    );

    if (sortKey === "price-asc") {
      sorted.sort(
        (a, b) => Number(a.dataset.price) - Number(b.dataset.price),
      );
    } else if (sortKey === "price-desc") {
      sorted.sort(
        (a, b) => Number(b.dataset.price) - Number(a.dataset.price),
      );
    } else {
      sorted.sort(
        (a, b) => Number(a.dataset.index) - Number(b.dataset.index),
      );
    }

    sorted.forEach((product) => grid.appendChild(product));
    products
      .filter((product) => !product.classList.contains("visible"))
      .forEach((product) => grid.appendChild(product));
  }

  visibleProductCount() {
    return this.refs.products.filter((product) =>
      product.classList.contains("visible"),
    ).length;
  }
}

if (!customElements.get("collection-component")) {
  customElements.define("collection-component", CollectionComponent);
}

class CollectionsListComponent extends Component {
  requiredRefs = ["filters", "collections"];

  connectedCallback() {
    super.connectedCallback();
  }

  changeVisibleCollection(clickedElement) {
    this.refs.collections.forEach((collection) => {
      if (clickedElement.dataset.handle === "all") {
        collection.classList.remove("hidden");
        return;
      } else {
        if (collection.dataset.handle !== clickedElement.dataset.handle) {
          collection.classList.add("hidden");
        } else {
          collection.classList.remove("hidden");
        }
      }
    });
    // CLOSE THE FILTER
  }

  changeVisibleScents(clickedElement) {
    if (!this.refs.collections) return;
    this.refs.collections.forEach((collection) => {
      collection.filterScent(clickedElement);
      const hasVisibleProducts =
        Array.from(
          collection
            .querySelector(".collection-component-bottom")
            .querySelectorAll(":scope > .visible"),
        ).length > 0;
      if (!hasVisibleProducts) {
        collection.classList.add("scent_hidden");
      } else {
        collection.classList.remove("scent_hidden");
      }
    });
    // CLOSE THE FILTER
  }
}

if (!customElements.get("custom-collections-component")) {
  customElements.define("collections-list-component", CollectionsListComponent);
}

class CollectionFiltersComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.collectionsElement = this.parentElement;
    this.categoryFilters = this.querySelector(
      "[data-type='category'] .collections-list-filters-options",
    );
    this.scentFilters = this.querySelector(
      "[data-type='scent'] .collections-list-filters-options",
    );
  }

  handleFilterClick(event) {
    const clickedElement = event.target.closest("li");
    const filterGroup = event.target.closest("[data-type]");
    const filterType = filterGroup?.dataset.type;
    const filterElement =
      filterType == "category" ? this.categoryFilters : this.scentFilters;
    this.changeFilterDisplayValue(clickedElement, filterElement);
    if (filterType == "category") {
      this.changeVisibleCollections(clickedElement);
      // CLOSE THE FILTER
      filterElement?.blur();
    } else if (filterType == "scent") {
      this.changeVisibleScents(clickedElement);
      // CLOSE THE FILTER
    }
  }

  changeFilterDisplayValue(clickedElement, filter) {
    if (!clickedElement || !filter) return;
    filter.prepend(clickedElement); // Moves clicked element to the beginning
  }

  changeVisibleCollections(clickedElement) {
    if (!this.collectionsElement) return;
    this.collectionsElement.changeVisibleCollection(clickedElement);
  }

  changeVisibleScents(clickedElement) {
    if (!this.collectionsElement) return;
    this.collectionsElement.changeVisibleScents(clickedElement);
  }
}

if (!customElements.get("collection-filters-component")) {
  customElements.define(
    "collection-filters-component",
    CollectionFiltersComponent,
  );
}
